export function getCertBaseUrl(fallbackOrigin: string) {
  const configuredBaseUrl = process.env.NEXT_PUBLIC_CERT_BASE_URL?.trim();
  return (configuredBaseUrl || fallbackOrigin).replace(/\/+$/, '');
}
